import { Button, Form, Input, Spin, notification } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import UserProfile from '../models/userProfile'
import { getCard } from '../repositories/apiRepo'
import { login } from '../repositories/authRepo'
import { cardAtom } from '../store/card'
import { userProfileAtom } from '../store/userProfile'
import { FormLogin } from '../types'
import { toCamelCase } from '../utils'
import useAuth from '../usecases/useAuth'

const Login = () => {
  const navigate = useNavigate()
  const { userProfile, isLoadingProfile } = useAuth()
  const [, setUserProfile] = useRecoilState(userProfileAtom)
  const [isLoading, setLoading] = useState(false)
  const [, setCard] = useRecoilState(cardAtom)

  const handleLogin = async (formValues: FormLogin) => {
    setLoading(true)
    try {
      const loginRes = await login(formValues)
      const cardRes = await getCard()
      if (cardRes.data) {
        setCard({
          cardNumber: cardRes.data.card_number,
          cardExpireAt: cardRes.data.card_expire_at,
          cardHolderName: cardRes.data.card_holder_name
        })
      }
      setUserProfile(toCamelCase<UserProfile>(loginRes.user) as UserProfile)
    } catch (err) {
      notification.error({
        message: 'ログイン失敗',
        description: '認証に失敗しました'
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (userProfile) {
      navigate('/')
    }
  }, [navigate, userProfile])
  if (isLoadingProfile)
    return <Spin className='h-full w-full justify-center flex items-center' />

  return (
    <div>
      <div className='w-full px-8 lg:w-[360px] lg:px-0 bg-green mx-auto pt-24 lg:pt-32'>
        <div className='flex justify-center mb-12'>
          <img
            src='/horizontal-logo.png'
            alt='ノットボッチ'
            className='w-64 h-auto'
          />
        </div>
        <Form layout='vertical' requiredMark='optional' onFinish={handleLogin}>
          <Form.Item
            name='email'
            label='メールアドレス'
            required
            rules={[
              { required: true, message: '入力してください' },
              {
                type: 'email',
                message: 'メールアドレスを正しく入力してください'
              }
            ]}
            normalize={(value) => value.trim()}
          >
            <Input size='large' maxLength={254} />
          </Form.Item>
          <Form.Item
            name='password'
            label='パスワード'
            required
            rules={[
              { required: true, message: '入力してください' },
              { min: 8, message: 'パスワークを正しく入力してください' },
              { max: 16, message: 'パスワークを正しく入力してください' }
            ]}
          >
            <Input
              size='large'
              type='password'
              autoComplete='off'
              maxLength={254}
            />
          </Form.Item>
          <div className='w-full flex justify-center mt-12'>
            <Button
              type='primary'
              htmlType='submit'
              size='large'
              className='min-w-[10rem]'
              loading={isLoading}
            >
              ログイン
            </Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default Login
